import { CircularProgress } from '@mui/material';
import Box from '@mui/material/Box';
import { paths } from 'config/paths';
import * as React from 'react';

import { PortalActionCard } from '~ui-components/components/molecules/portal-action-card';

import { ItemCard } from './items/item-card';

import { DataViewProps } from '.';

export function DataPortalLargeView(props: DataViewProps): React.JSX.Element {
	const { isLoading, items, onItemDelete } = props;

	return (
		<Box
			sx={{
				display: 'grid',
				gap: 4,
				gridTemplateColumns: {
					xs: '1fr',
					sm: 'repeat(1, 1fr)',
					md: 'repeat(2, 1fr)',
				},
			}}
		>
			<PortalActionCard
				title="Import Data"
				href={paths.accountName.data.import('john-doe')}
			/>
			{isLoading && (
				<Box sx={{ p: 2 }}>
					<CircularProgress />
				</Box>
			)}
			{Array.from(items.values()).map((item) => (
				<ItemCard
					size="large"
					item={item}
					key={item.id}
					onDelete={onItemDelete}
				/>
			))}
		</Box>
	);
}
